import redRoses25 from "../img/trandafiri/25-red-roses.webp";
import roses101white from "../img/trandafiri/101-white-infinity.webp";
import roses101red from "../img/trandafiri/101-red-infinity.webp";
import delight from "../img/trandafiri/delight.webp";
import pastel from "../img/trandafiri/pastel-rose.webp";
import lidia from "../img/trandafiri/lidia-rose.webp";
import sunnyHills from "../img/trandafiri/1suuny-hills.webp";
import winterSilvaPink from "../img/trandafiri/2winter-silva-pink.webp";
import bloom from "../img/cele-mai-vindute/Bloom.webp";
import pinkSpray from "../img/trandafiri/pink-spray.webp";
// import rosewood from "../img/trandafiri/rosewood.webp";
import silvaPinkDeluxe from "../img/buchete-premium/8silva-pink-deluxe.webp";
import silvaPinkMidi from "../img/trandafiri/silva-pink-midi.webp";
import pinkdelight from "../img/new/016pinkdelight.webp";
import silkspring from "../img/new/018silkspring.webp";
import lovesgarden from "../img/new/008lovesgarden.webp";
// import zinnia from "../img/new/004zinnia.webp";
import springpromise from "../img/new/009springpromise.webp";
import springtimeromance from "../img/new/010springtimeromance.webp";
import beSweet from "../img/may2026/12_be_sweet.webp";
//200-250
const bucheteTrandafiri = [
  {
    id: 200,
    name: "Pink Delight",
    price: "1300 lei",
    description:
      "Buchet format din trandafiri de tip bujor si verdeata decorativa.",
    images: [pinkdelight],
  },
  {
    id: 1091,
    name: "Be Sweet",
    price: "3000 lei",
    description: "Buchet format din 35 trandafiri roz de lungime 80cm. ",
    images: [beSweet],
  },
  // {
  //   id: 202,
  //   name: "Zinnia",
  //   price: "1300 lei",
  //   description: "Buchet format din trandafiri,eucalipt si asothamus.",
  //   images: [zinnia],
  // },
  {
    id: 204,
    name: "Springtime Romance",
    price: "1350 lei",
    description:
      "Buchet format din trandafiri de tip bujor, trandafiri Country si eucalipt.",
    images: [springtimeromance],
  },
  {
    id: 205,
    name: "Silk Spring",
    price: "550 lei",
    description:
      "Buchet format din trandafiri Sofia, dianthus, trandafiri crenguta si eucalipt.",
    images: [silkspring],
  },
  {
    id: 206,
    name: "25 Red Roses",
    price: "2200 lei",
    description: "Buchet extravagant format din 25 trandafiri rosii. ",
    images: [redRoses25],
  },
  {
    id: 207,
    name: "101 White Infinity",
    price: "8500 lei",
    description:
      "Buchet extravagant de marime XXL format din 101 trandafiri albi. ",
    images: [roses101white],
    // checkAvailability: true,
  },
  {
    id: 208,
    name: "101 Red Infinity",
    price: "8000",
    description:
      "Buchet extravagant de marime XXL format din 101 trandafiri rosii.",
    images: [roses101red],
    // checkAvailability: true,
  },
  {
    id: 209,
    name: "Silva Pink Midi",
    price: "1100 lei",
    description:
      "Buchet elegant format din trandafiri de tip bujor si verdeata decorativa.",
    images: [silvaPinkMidi],
  },
  {
    id: 210,
    name: "Lidia",
    price: "900 lei",
    description:
      "Buchet elegant format din trandafiri de tip crengura de culoare roz.",
    images: [lidia],
  },
  {
    id: 211,
    name: "Delight",
    price: "2300 lei",
    description:
      "Buchet superb format din trandafiri de tip bujor, trandafiri avalanche si eucalipt.",
    images: [delight],
  },
  {
    id: 212,
    name: "Pink Spray",
    price: "950 lei",
    description:
      "Buchet elegant format din trandafiri de tip crenguta, hipericum si gipsofila.",
    images: [pinkSpray],
  },
  {
    id: 216,
    name: "Pastel Rose",
    price: "1100 lei",
    description:
      "Buchet elegant format din mix de trandafiri cu adaos de eucalipt.",
    images: [pastel],
    // checkAvailability: true,
  },
  {
    id: 217,
    name: "Sofia",
    price: "1800 lei",
    description:
      "Buchet elegant format din trandafiri crenguta de soi Sofia, eustome albe si eucalipt..",
    images: [sunnyHills],
    // checkAvailability: true,
  },
  {
    id: 218,
    name: "Winter Silva Pink",
    price: "4000 lei",
    description:
      "Buchet de amrime XL format din trandafiri de tip bujor Silva Pink si eucalipt.",
    images: [winterSilvaPink],
  },
  {
    id: 220,
    name: "Silva Pink Deluxe",
    price: "4000 lei",
    description:
      "Buchet rafinat format din trandafiri Silva Pink si eucalipt. ",
    images: [silvaPinkDeluxe],
  },
  // {
  //   id: 219,
  //   name: "Rosewood",
  //   price: "1150 lei",
  //   description:
  //     "Buchet elegant format dintr-un mix de trandafiri de tip bujor, trandafiri Sofia, trandafiri Avalanche si eucalipt.",
  //   images: [rosewood],
  // },
  {
    id: 225,
    name: "Bloom",
    price: "2200 lei",
    description:
      "Buchet superb format din trandafiri de tip Bujor, lalele și eucalipt.",
    images: [bloom],
    // checkAvailability: true,
  },
];
// pot sa adaug id 27,28,29 ca urmatoarea sectie incepe de la 30
export default bucheteTrandafiri;
